<template>
    <div class="ocrContainer">
        <div class="bottom">
            <FileUploadAreaAadhaar
                @filesSelected="filesSelected"
                @removeFile="removeFile"
            />
            <small class="form-group--error-message" v-if="isOcrFailure"> OCR Failed </small>
        </div>
        <div style="display: flex; justify-content: center; align-items: center; margin-top: 20px !important" class="register__form--referral-bottom">
            <button class="aadhaar-ocr btn_new btn-secondary-new w-80"
                @click="submitOcr"
                :disabled="disableSubmitButton()"
            >
                Submit
            </button>
        </div>
        <v-snackbar
            v-model="isOcrFailure"
            app
            timeout="-1"
        >
                {{failureText}}

            <template v-slot:action="{ attrs }">
                <v-btn
                    color="red"
                    text
                    v-bind="attrs"
                    @click="isOcrFailure = false"
                >
                Close
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import onboardingService from '@/services/lenderOnboardingService'
import Compressor from 'compressorjs'
import FileUploadAreaAadhaar from '@/components/common/fileUploadAreaAadhaar.vue'
const { isDate } = require('@/util/util.js')

export default {
    name: 'AadhaarOCR',
    components: {
        FileUploadAreaAadhaar
    },
    data () {
        return {
            aadhaarFrontImage: '/img/aadhar-1.png',
            aadhaarBackImage: '/img/aadhar-1.png',
            aadhaarFront: null,
            aadhaarBack: null,
            failureText: false,
            isOcrFailure: false,
            files: [],
            sendFiles: []
        }
    },
    methods: {
        disableSubmitButton () {
            if (this.sendFiles.length) {
                return false
            }
            return true
        },
        submitOcr () {
            this.$store.commit('isLoading')
            const payload = {
                documentType: 'aadhaar',
                files: this.sendFiles
            }
            console.log('[pay]', payload)
            onboardingService.aadhaarOcr(payload).then((res) => {
                if (res.status === 200) {
                    this.aadhaarNo = res.data.aadhaarNumber
                    if (isDate(res.data.dob)) {
                        this.$store.dispatch('onBoarding/setField', { field: 'dob', value: res.data.dob })
                    }
                    this.$store.dispatch('onBoarding/setField', { field: 'Aadhaar', value: res.data.aadhaarNumber })
                    this.$store.dispatch('onBoarding/setField', { field: 'Name', value: res.data.aadhaarName })
                    this.$store.dispatch('setUserName', res.data.aadhaarName)
                    this.isOcrSuccess = true
                    this.success()
                } else if (res.status === 422) {
                    this.isOcrFailure = true
                    this.failureText = 'Please upload both front and back side of Aadhaar'
                } else {
                    this.isOcrFailure = true
                    this.failureText = 'Please ensure uploaded Images are correct!'
                }
                this.$store.commit('isNotLoading')
            })
        },
        filesSelected (files) {
            this.files.push(files)
            this.convertBlob()
        },
        removeFile (file) {
            var index = this.files.indexOf(file)
            this.files.splice(index, 1)
            this.convertBlob()
        },
        convertBlob () {
            this.sendFiles = []
            for (var i = 0; i < this.files.length; i++) {
                this.handleFile(this.files[i])
            }
        },
        handleFile (file) {
            const selectedImage = file
            if (file.type !== 'application/pdf') {
                const comp = new Compressor(selectedImage, { quality: 0.6 })
                comp.done = (e) => {
                    if (e?.result?.size < 3146000) {
                        return this.createBase64Image(e.result)
                    } else {
                        this.displayImageSizeError()
                    }
                }
            } else {
                if (file.size < 3146000) {
                    return this.createBase64Image(file)
                } else {
                    this.displayImageSizeError()
                }
            }
        },
        createBase64Image (fileObject) {
            const reader = new FileReader()
            reader.onload = (e) => {
                let base64 = e.target.result
                base64 = base64.split(',')[1]
                this.sendFiles.push(base64)
            }
            reader.readAsDataURL(fileObject)
        },
        displayImageSizeError () {
            this.failureText = 'Image size is too large. Please upload an Image under 3 MB'
            this.isOcrFailure = true
        },
        success () {
            this.$emit('success')
        }
    }
}
</script>

<style lang="scss" scoped>
@import "~@/sass/components/registration-flow.scss";

    .ocrContainer {
        position: relative;
        top: 40px;
    }
    .aadhaar-ocr {}
</style>
